type ScrollerInstance = {
  canvasScroller: any;
  config: any;
  borderWidth: any;
  scrollerGraphColor: any;
  borderColor: any;
  selectionRangeColor: any;
  selectionRangeHoverColor: any;
  scrollerGraphWidth: any;
  numberOfVisibleChannels: any;
  wndDuration: any;
  gain: any;
  ctxScroller: any;
  verticalChannelPlacement: any;
  samples: any;
  aspectRatioX: any;
  aspectRatioY: any;
  secondsToPix: any;
  indexToPix: any;
  majorDivSize: any;
  millivoltToPix: any;
  xRange: any;
  startX: any;
  draw: (...args: any[]) => any;
  drawBorder: (...args: any[]) => any;
  drawScrollerChart: (...args: any[]) => any;
  drawSelectionRange: (...args: any[]) => any;
  recalculateScaleFactors: (...args: any[]) => any;
  prepareAllPixelSamples: (...args: any[]) => any;
  decimateSamples: (...args: any[]) => any;
};

let Scroller;

(function () {
  Scroller = function (
    this: ScrollerInstance,
    canvasScroller: any,
    samples: any = [[], [], []],
    config: any,
    prevChanIdx: any,
  ) {
    this.canvasScroller = canvasScroller;
    this.config = config;
    this.borderWidth = 3;
    this.scrollerGraphColor = '#000';
    this.borderColor = '#0954BA';
    this.selectionRangeColor = '#0954BA40';
    this.selectionRangeHoverColor = '#0954BA80';
    this.scrollerGraphWidth = 1.3;
    this.numberOfVisibleChannels = 1;
    this.wndDuration = this.config.recDuration;
    this.gain = this.config.gain * 2;
    this.ctxScroller = canvasScroller.getContext('2d');

    this.recalculateScaleFactors();

    this.prepareAllPixelSamples(samples[prevChanIdx]);
  };

  Scroller.prototype.draw = function (this: ScrollerInstance, offsetX: any, isHover: any) {
    this.canvasScroller.clear();

    this.drawBorder();
    this.drawSelectionRange(offsetX, isHover);
    this.drawScrollerChart();
  };

  Scroller.prototype.drawBorder = function (this: ScrollerInstance) {
    const { width, scrollerHeight } = this.config;
    this.ctxScroller.beginPath();
    this.ctxScroller.lineWidth = this.borderWidth;
    this.ctxScroller.strokeStyle = this.borderColor;
    this.ctxScroller.moveTo(0, 0);
    this.ctxScroller.lineTo(0, scrollerHeight);
    this.ctxScroller.lineTo(width, scrollerHeight);
    this.ctxScroller.lineTo(width, 0);
    this.ctxScroller.lineTo(0, 0);
    this.ctxScroller.stroke();
    this.ctxScroller.closePath();
  };

  Scroller.prototype.drawScrollerChart = function (this: ScrollerInstance) {
    this.ctxScroller.beginPath();
    this.ctxScroller.lineWidth = this.scrollerGraphWidth;
    this.ctxScroller.strokeStyle = this.scrollerGraphColor;
    for (let j = 0; j < this.samples.length - 1; j += 1) {
      this.ctxScroller.moveTo(this.samples[j].x, this.samples[j].y);
      this.ctxScroller.lineTo(this.samples[j + 1].x, this.samples[j + 1].y);
    }
    this.ctxScroller.stroke();
    this.ctxScroller.closePath();
  };

  Scroller.prototype.drawSelectionRange = function (
    this: ScrollerInstance,
    offsetX = 0,
    isHover: any,
  ) {
    const { scrollerHeight, sampleLength, width } = this.config;

    this.startX = (offsetX * width) / sampleLength;

    this.ctxScroller.beginPath();
    this.ctxScroller.fillStyle = isHover ? this.selectionRangeHoverColor : this.selectionRangeColor;
    this.ctxScroller.moveTo(this.startX, 0);
    this.ctxScroller.lineTo(this.startX, scrollerHeight);
    this.ctxScroller.lineTo(this.startX + this.xRange, scrollerHeight);
    this.ctxScroller.lineTo(this.startX + this.xRange, 0);
    this.ctxScroller.lineTo(this.startX, 0);
    this.ctxScroller.fill();
    this.ctxScroller.closePath();
  };

  Scroller.prototype.recalculateScaleFactors = function (this: ScrollerInstance) {
    const { width, speed, samplingRate } = this.config;

    this.aspectRatioX = width / this.wndDuration / speed;
    this.aspectRatioY = this.aspectRatioX;
    this.secondsToPix = speed * this.aspectRatioX;
    this.indexToPix = (speed * this.aspectRatioX) / samplingRate;
    this.majorDivSize = width / this.wndDuration;
    this.millivoltToPix = this.gain * this.aspectRatioY;
    this.xRange = this.config.wndDuration * this.secondsToPix;
  };

  Scroller.prototype.prepareAllPixelSamples = function (this: ScrollerInstance, physSamples: any) {
    const { scrollerHeight, width } = this.config;
    this.verticalChannelPlacement = [];
    for (let chIdx = 0; chIdx < physSamples.length; chIdx += 1) {
      this.verticalChannelPlacement.push(
        (scrollerHeight / this.numberOfVisibleChannels) * (chIdx + 0.5),
      );
    }
    // this.verticalChannelPlacement = physSamples.map((chArr, chIdx) => scrollerHeight / this.numberOfVisibleChannels * (chIdx + 0.5));
    const bucketSize = Math.floor(physSamples.length / width);
    const decimatedArr = this.decimateSamples(physSamples, bucketSize);
    this.samples = [];
    for (let i = 0; i < decimatedArr.length; i += 1) {
      this.samples.push({
        x: Math.floor(i * bucketSize * this.indexToPix),
        y: Math.floor(this.verticalChannelPlacement[0] - decimatedArr[i] * this.millivoltToPix),
      });
    }
    // this.samples = decimatedArr.map((u, i) => ({
    //   x: Math.floor(i * bucketSize * self.indexToPix),
    //   y: Math.floor(self.verticalChannelPlacement[0] - u * this.millivoltToPix),
    // }));
  };

  Scroller.prototype.decimateSamples = function (samples: any, bucketSize: any) {
    let decimatedArr = [];
    if (bucketSize > 1) {
      for (let i = 0; i <= samples.length - bucketSize; i += bucketSize) {
        const bucket = samples.slice(i, i + bucketSize);
        const max = Math.max.apply(null, bucket);
        const min = Math.min.apply(null, bucket);
        const prevSelected: any = i === 0 ? 0 : decimatedArr[decimatedArr.length - 1];
        const selectedVal: any =
          Math.abs(prevSelected - max) > Math.abs(prevSelected - min) ? max : min;
        decimatedArr.push(selectedVal);
      }
    } else {
      decimatedArr = samples;
    }
    return decimatedArr;
  };

  Scroller.prototype.update = function (
    this: ScrollerInstance,
    samples: any,
    config: any,
    prevChanIdx: any,
  ) {
    this.config = config;
    this.wndDuration = this.config.recDuration;
    this.xRange = this.config.wndDuration * this.secondsToPix;
    this.gain = this.config.gain * 2;

    this.recalculateScaleFactors();

    this.prepareAllPixelSamples(samples[prevChanIdx]);
  };

  Scroller.prototype.updatePrevChanIdx = function (
    this: ScrollerInstance,
    samples: any,
    offsetX: any,
    prevChanIdx: any,
  ) {
    this.prepareAllPixelSamples(samples[prevChanIdx]);

    this.draw(offsetX, false);
  };

  Scroller.prototype.checkClickInsideSelectionRange = function (
    this: ScrollerInstance,
    xPoint: any,
    yPoint: any,
  ) {
    const { scrollerHeight } = this.config;
    if (
      xPoint >= this.startX &&
      xPoint <= this.startX + this.xRange &&
      yPoint >= 0 &&
      yPoint <= scrollerHeight
    ) {
      return true;
    }
    return false;
  };
})();

export { Scroller };
export default { Scroller };
